import { styled } from "styled-components";
import { Divider, Skeleton } from "antd";
import { scrollBarStyles } from "@dataone/lib";
import { SearchIcon } from "@dataone/icons";

interface AskAboutProps {
  suggestion?: string[];
  setSelectedSearch: React.Dispatch<React.SetStateAction<{ message: string }>>;
}

function AskAbout({ suggestion, setSelectedSearch }: AskAboutProps) {
  return (
    <StyledAskAbout>
      <StyledTitle>
        <div className="title">Also Ask about</div>
        <StyledDivider>
          <Divider className="divider" />
        </StyledDivider>
      </StyledTitle>
      <div className="content">
        {suggestion ? (
          suggestion.map((search) => (
            <StyledContainer
              key={search}
              onClick={() => setSelectedSearch({ message: search })}
            >
              <StyledSearchIcon>
                <SearchIcon />
              </StyledSearchIcon>
              <div className="search-desc">{search}</div>
            </StyledContainer>
          ))
        ) : (
          <>
            <Skeleton.Input active block size="small" />
            <Skeleton.Input active block size="small" />
            <Skeleton.Input active block size="small" />
          </>
        )}
      </div>
    </StyledAskAbout>
  );
}

export default AskAbout;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 5px 0px;
  cursor: pointer;

  &:hover {
    background: #fff;
  }
  .search-desc {
    color: #4974f6;
    font-size: 13px;
    font-weight: 300;
    max-width: 91%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .search-icon img {
    width: 15px;
    height: 15px;
  }
`;
const StyledAskAbout = styled.div`
  .content {
    // overflow-y: auto;
    max-height: 154px;
    // ${scrollBarStyles}
  }

  .ant-skeleton {
    padding: 13px 20px 0;
  }
`;
const StyledTitle = styled.div`
  .title {
    min-width: 130px;
    font-size: 13px;
  }
  display: flex;
  flex-direction: row;
  color: rgba(4, 7, 38, 0.6);
  font-size: 14px;
  font-weight: 400;
  padding: 10px;
  margin-top: 10px;
`;
const StyledDivider = styled.div`
  width: 85%;
  margin-top: -15px;
  margin-left: auto;
  .divider {
    border: 1px solid #b4c6fa;
  }
`;

const StyledSearchIcon = styled.div`
  margin: 0px 15px;
`;
